export class PromotionRewardModel {
    id: number;
    name: string;
    description: string;
}